import type { ReceiptTemplate } from '../schema';

export const jollibeeTemplate: ReceiptTemplate = {
  id: 'jollibee',
  name: 'Jollibee Receipt',
  brand: 'JOLLIBEE',
  description: 'Jollibee fast food restaurant receipt template',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'narrow',
  },
  sections: [
    {
      id: 'jollibee-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/jolibee.png',
        logoData: '',
        logoWidth: 120,
        logoHeight: 60,
        businessName: '',
        businessNameFontSize: 20,
        addressLines: [
          'JOLLIBEE #1847',
          '1200 DARK AVENUE',
          'MONSTERVILLE, CA 94608',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'jollibee-order',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'ORDER #847',
        fontSize: 18,
        showDivider: true,
        dividerStyle: 'spaces',
        isBold: true,
      },
    },
    {
      id: 'jollibee-trans',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: 'DINE IN\n01/04/26 12:30  REG 02  MARIA',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'dashed',
        isBold: false,
      },
    },
    {
      id: 'jollibee-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        showQuantity: true,
        showPrice: true,
        showTotal: false,
        items: [
          { id: 'jollibee-item-1', name: 'CHICKENJOY 2PC MEAL', quantity: '1', price: '8.99'},
          { id: 'jollibee-item-2', name: '  RICE', quantity: '1', price: '0.00'},
          { id: 'jollibee-item-3', name: '  MED DRINK', quantity: '1', price: '0.00'},
          { id: 'jollibee-item-4', name: 'JOLLY SPAGHETTI', quantity: '1', price: '5.49'},
          { id: 'jollibee-item-5', name: 'PEACH MANGO PIE', quantity: '2', price: '3.98'},
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'jollibee-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 35,
        labelAlignment: 'left',
        lines: [
          { id: 'jollibee-subtotal', label: 'SUBTOTAL', value: '18.46', isBold: false, isLarge: false },
          { id: 'jollibee-tax', label: 'TAX', value: '1.64', isBold: false, isLarge: false },
          { id: 'jollibee-total', label: 'TOTAL', value: '20.10', isBold: true, isLarge: true },
        ],
        increaseTotalSize: true,
        totalSizeIncrease: 20,
        showDivider: true,
        dividerStyle: 'double',
      },
    },
    {
      id: 'jollibee-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        paymentType: 'card',
        cardFields: [
          { id: 'jollibee-card', label: 'VISA', value: '************4144' },
          { id: 'jollibee-auth', label: 'AUTH', value: '847291' },
        ],
        cashFields: [],
        showDivider: true,
        dividerStyle: 'spaces',
      },
    },
    {
      id: 'jollibee-barcode',
      type: 'barcode',
      enabled: true,
      config: {
        alignment: 'center',
        type: 'code128',
        value: '18478470104261230',
        showValue: false,
        width: 1.5,
        height: 35,
        showDivider: false,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'jollibee-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'BIDA ANG SAYA!\nTHANK YOU FOR CHOOSING JOLLIBEE',
        fontSize: 10,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
};
